import { inject, Injectable, signal } from '@angular/core';
import { Validators } from '@angular/forms';
import { DetailAttribute } from '../../../../shared/models/shared.model';
import { GroupApiCallService } from '../group-api-call.service';

@Injectable({ providedIn: 'root' })
export class RuleRangeTypeGroupService {
    private groupApiCallService = inject(GroupApiCallService);

    private ruleRangeTypeGroupAttributes: DetailAttribute[] = [
        {
            label: 'Range Types',
            name: 'rulerangetypes',
            apiName: 'rangeTypeId',
            type: 'select',
            placeholder: 'Select a tenant first',
            control: [Validators.required],
            dependency: 'tenantId',
        },
        {
            label: 'Rule Types',
            name: 'ruletypes',
            apiName: 'ruleTypeId',
            type: 'select',
            placeholder: 'Select a rule type',
            control: [Validators.required],
        },
        {
            label: 'Multipliers',
            name: 'multipliers',
            apiName: 'multipliers',
            type: 'table',
            placeholder: 'Add ranges',
            control: [Validators.required],
        },
    ];

    loadGroupAttributes(): DetailAttribute[] {
        return this.ruleRangeTypeGroupAttributes;
    }

    getRangeTypes(tenantId: number) {
        return this.groupApiCallService.getDetailSelectData(
            'RuleRangeGroups',
            'rulerangetypes',
            { name: 'tenants', parentId: tenantId },
        );
    }

    getRuleTypes() {
        return this.groupApiCallService.getDetailSelectData(
            'RiskRules',
            'ruletypes',
            undefined,
            { key: 'isGeneral', value: 'false' },
        );
    }
}
